import { Box, Button, ButtonAppearance, ButtonSize, Icon, Popover, Text } from '@bechtel/gds';
import { MetadataTableName } from '@bechtel/sr-types';
import { includes } from 'lodash';
import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ChangeManagementToolBar, CommodityActions, FormMode, MultiLingualText } from '~/components';
import { CommodityHeaderStyled, TagStyled } from './styled';

interface CommodityHeaderProps {
  commodityName: MetadataTableName;
  showAdditionalInfo: boolean;
  setShowAdditionalInfo: (value: boolean) => void;
  disableClone?: boolean;
  disableDelete?: boolean;
  tag?: string;
  enableOptions?: boolean;
  mode?: string;
  enableActions?: boolean;
  customComponent?: JSX.Element;
  isRestricted?: boolean;
}
export const CommodityHeader: React.FC<CommodityHeaderProps> = ({
  commodityName,
  showAdditionalInfo,
  setShowAdditionalInfo,
  disableClone,
  disableDelete,
  tag,
  enableOptions = true,
  mode,
  enableActions = false,
  customComponent,
  isRestricted = false,
}) => {
  const elementRef = useRef(null);
  const params = useParams();
  const [showPopover, setShowPopover] = useState<boolean>(false);
  return (
    <CommodityHeaderStyled>
      <Box flexGrow={{ sm: ' 1' }}>
        <Box px={{ sm: '500' }} alignItems={{ sm: 'center' }}>
          {/* For FormMode.CREATE and FormMode.CLONE, tag will be text like Cloned or Add New. adding multilingual for that */}
          {includes([FormMode.CREATE, FormMode.CLONE], mode) ? (
            <MultiLingualText color="primary.900" weight="700">
              {tag}
            </MultiLingualText>
          ) : (
            <Text color="primary.900" weight="700">
              {tag}
            </Text>
          )}
          <TagStyled>
            <MultiLingualText color="white" size="300">
              {commodityName}
            </MultiLingualText>
          </TagStyled>
        </Box>
        {isRestricted && (
          <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'top' }}>
            <MultiLingualText color="red.500" weight="700" size="300">
              RESTRICTED
            </MultiLingualText>
          </Box>
        )}
      </Box>
      {(params?.['*'] === 'details' || params?.['*'] === 'general') && <ChangeManagementToolBar mode={mode} />}
      {customComponent && <Box>{customComponent}</Box>}

      <Box px={{ sm: '300' }} alignItems={{ sm: 'center' }}>
        {(params?.['*'] === 'details' || params?.['*'] === 'general' || enableActions) && (
          <CommodityActions
            canAddItem={!disableClone}
            canDeleteItem={!disableDelete}
            commodityName={commodityName}
            tag={tag ? tag : ''}
            enableOptions={enableOptions}
            formMode={mode}
          />
        )}
        {!showAdditionalInfo && (
          <Box ml={{ sm: '200' }}>
            <div ref={elementRef}>
              <Button
                appearance={ButtonAppearance.PRIMARY}
                size={ButtonSize.SMALL}
                onMouseOver={() => setShowPopover(true)}
                onMouseLeave={() => setShowPopover(false)}
                onClick={() => {
                  setShowPopover(false);
                  setShowAdditionalInfo(true);
                }}
              >
                <Icon
                  icon="arrow-to-right"
                  iconStyle="regular"
                  fillColor="white"
                  style={{ transform: 'rotate(180deg)' }}
                />
              </Button>
            </div>
            <Popover
              triggerComponentRef={elementRef}
              showPopper={showPopover}
              customStyle={{ backgroundColor: 'black', color: 'white' }}
              placement="left"
            >
              <Box py={{ sm: '300' }} px={{ sm: '400' }}>
                <MultiLingualText size="300" color="white" family="openSansCondensed">
                  Expand
                </MultiLingualText>
              </Box>
            </Popover>
          </Box>
        )}
      </Box>
    </CommodityHeaderStyled>
  );
};
